export const ASSETS = {
  LOGOS: {
    TRANSPARENT: '/images/logos/logo_transparente.png',
  },
} as const 

// Cores principais do projeto
export const COLORS = {
  PRIMARY_BLUE: '#3DB2FF',
  DANGER_RED: '#FF0000'
} as const 